import dayjs from 'lib/dayjs-setup';

export default function dateToString(_date?: string): string {
  if (_date) {
    return dayjs(_date).format('MM.DD.YYYY');
  } 
  else {
    return '';
  }
}
